export default {"src":"/_next/static/media/initPing.f906efa9.svg","height":88,"width":172};